export default "__VITE_ASSET__DfMj9rEc__"